import { ReactNode } from 'react';

import { useI18n } from '@app-velocity/i18n';
import { MessageBus } from '@app-velocity/message-bus';

import { StyledLinkToEdit, StyledDataSection, SectionHeading } from '../styled';

type DataSectionProps = {
  children?: ReactNode;
};

const messageBus = new MessageBus('users');

export const EmailSection = ({
  children,
}: DataSectionProps) => {
  const { t } = useI18n();

  const clickHandler = () => {
    messageBus.publish('modal:edit-email:open');
  };

  return (
    <StyledDataSection>
      <SectionHeading>{t('users:email')}</SectionHeading>
      {children}
      <StyledLinkToEdit onClick={clickHandler}>
        {t('users:settings.change_email')}
      </StyledLinkToEdit>
    </StyledDataSection>
  );
};
